module.exports = __webpack_public_path__ + "static/img/应用中心1@2x.24559d9.webp";


//////////////////
// WEBPACK FOOTER
// ./static/webp2/应用中心1@2x.webp
// module id = wN/g
// module chunks = 1